import { toRaw } from 'vue'
export const initialAnswers = (saved = {}) => structuredClone(toRaw(saved))
export function validateAnswers(schema, answers, submit = true) {
  if (Object.keys(answers).some(key => !schema.some(q => q.id === key))) throw new Error('Unknown question.')
  const clean = {}
  for (const q of schema) {
    let value = answers[q.id]
    if (value == null || (typeof value === 'string' && !value.trim())) {
      if (submit && q.required) throw new Error('Please complete required questions.')
      continue
    }
    let valid = false
    if (q.type === 'short_text') { valid = typeof value === 'string' && value.length <= 2000; if (valid) value = value.trim() }
    if (q.type === 'single_choice') valid = q.options.includes(value)
    if (['number', 'scale'].includes(q.type)) valid = typeof value === 'number' && Number.isFinite(value) && value >= q.min && value <= q.max && (q.type !== 'scale' || Number.isInteger(value))
    if (!valid) throw new Error(`Check your answer: ${q.prompt || q.id}`)
    clean[q.id] = value
  }
  return clean
}
export function ratingAnswer(value, min, max, submit = true) {
  if (!submit && (value == null || value === '')) return {}
  if (!Number.isInteger(value) || value < min || value > max) throw new Error(`Choose a whole-number score from ${min} to ${max}.`)
  return { score: value }
}
export function sampleAnswers(sample, answers, submit = true) {
  return validateAnswers([{ id: 'score', type: 'scale', min: 1, max: sample?.rating_max || 4, required: true }, ...(sample?.questions || [])], answers, submit)
}
export function logicalSubmit(makeId = () => crypto.randomUUID()) {
  let pending = false, retry = null
  return {
    get pending() { return pending },
    async run(path, body, send) {
      if (pending) throw new Error('A request is already pending.')
      const key = JSON.stringify([path, body])
      if (!retry || retry.key !== key) retry = { key, id: makeId() }
      pending = true
      try { const value = await send(retry.id); retry = null; return value } finally { pending = false }
    },
  }
}
